import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(299); // 4:59 in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full bg-cyber-dark border-b border-cyber-neon/30 overflow-hidden" data-id="element-303">
      {/* Pulsing background effect */}
      <motion.div className="absolute inset-0 bg-gradient-to-r from-cyber-red/10 via-cyber-neon/5 to-cyber-red/10" animate={{
      opacity: [0.3, 0.6, 0.3]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-304" />

      <div className="max-w-7xl mx-auto px-4 py-3 relative z-10 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-305">
        <div className="flex items-center gap-2 text-cyber-neon font-mono text-sm sm:text-base font-bold" data-id="element-306">
          <Zap className="w-4 h-4 animate-pulse" data-id="element-307" />
          <span data-id="element-308">OFERTA DE LANZAMIENTO LATAM: 85% de descuento vence en</span>
          <motion.span key={formattedTime} initial={{
          scale: 1.2,
          color: '#fff'
        }} animate={{
          scale: 1,
          color: '#FF003C'
        }} className="bg-cyber-black px-2 py-1 rounded border border-cyber-red text-cyber-red shadow-neon-red ml-1" data-id="element-309">
            {formattedTime}
          </motion.span>
        </div>

        <div className="hidden sm:block text-gray-500" data-id="element-310">—</div>

        <div className="text-gray-300 text-xs sm:text-sm font-mono" data-id="element-311">
          Solo quedan{' '}
          <span className="text-cyber-neon font-bold" data-id="element-312">
            12 accesos disponibles
          </span>{' '}
          a $6.36.
        </div>
      </div>
    </div>;
}